import React from "react";

function Restaurants({ text, language, paella }) {
  return (
    <div>
      <h2>{text[language].restaurants.title}</h2>
      <div
        className="paella-img-div"
        style={{ backgroundImage: `url(${paella})` }}
      ></div>
      <div className="topic-list">
        <div className="topic-item">
          <div>
            <h3>Bodega La Pascuala</h3>
            <p>Doctor lluch 299</p>
          </div>
          <p>{text[language].restaurants.bodegaText}</p>
        </div>
        <div className="topic-item">
          <div>
            <h3>La Paca</h3>
            <p>C/ del Rosario 30</p>
          </div>
          <p>{text[language].restaurants.pacaText}</p>
        </div>
        <div className="topic-item">
          <div>
            <h3>Casa Montaña</h3>
            <p>C/ de Josep Benlliure 69</p>
          </div>
          <p>{text[language].restaurants.casaMoText}</p>
        </div>
        <div className="topic-item">
          <div>
            <h3>Bodega Anyora</h3>
            <p>C/ d'En Vicent Gallart 15</p>
          </div>
          <p>{text[language].restaurants.bodegaAnyoraText}</p>
        </div>
        <div className="topic-item topic-bottom">
          <div>
            <h3>Bodega Aldeana 1927</h3>
            <p>C/ de Josep Benlliure 258</p>
          </div>
          <p>{text[language].restaurants.bodegaAldeanaText}</p>
        </div>
      </div>
    </div>
  );
}

export default Restaurants;
